/*
 * View for the Response History modal
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicResponseHistoryModal/template/topicResponseHistoryModalTemplate.html",
], function (Marionette, TopicResponseHistoryModalTemplate) {
  var TopicResponseHistoryModalView = {};

  TopicResponseHistoryModalView.topicResponseHistoryModalLayout = Marionette.Layout.extend({
    template: TopicResponseHistoryModalTemplate,
    regions: {
      historyList: "#responseHistoryList",
      historyPreview: "#responseHistoryPreview",
    },
  });

  return TopicResponseHistoryModalView;
});
